/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="96.08"
        height="85.22"
        viewBox="0 0 96.08 85.22"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M1.5 0a1.5 1.5 0 0 1 1.49 1.41v80.87h80.72a1.51 1.51 0 0 1 1.5 1.35v.15a1.49 1.49 0 0 1-1.35 1.49H1.5a1.5 1.5 0 0 1-1.49-1.36V1.5A1.5 1.5 0 0 1 1.5 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M93.52 8.89a1.5 1.5 0 0 1 2.23 2l-.1.11-37.34 37.52-14-13.89-29.4 29.57a1.49 1.49 0 0 1-2 .11l-.12-.1a1.5 1.5 0 0 1-.1-2l.1-.11 31.55-31.69 14 13.89Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'LineGraphUpwardsTrendIcon';

export default Icon;
